import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import { PGA_COM_HOST } from 'env'
import SectionEmptyState from 'components/section-empty-state'
import { TonalButton } from 'components/empty-page-state'
import ConfirmationNumberOutlinedIcon from 'components/material-symbol/icons/ConfirmationNumber'
import SearchIcon from 'components/material-symbol/icons/Search'
import { useStyles } from './styles'

const NoLessonPacksCard = ({ text }) => {
  const classes = useStyles()

  return (
    <Box className={classes.emptyStateContent}>
      <SectionEmptyState
        Icon={ConfirmationNumberOutlinedIcon}
        title="No Lesson Packs"
        caption={text}
        bordered={false}
        action={
          <TonalButton
            startIcon={<SearchIcon color="primary" />}
            onClick={() => window.open(`${PGA_COM_HOST}/golf-lessons`)}
          >
            Find Programs
          </TonalButton>
        }
      />
    </Box>
  )
}

NoLessonPacksCard.propTypes = {
  text: PropTypes.string,
}

export default NoLessonPacksCard
